module.exports = __webpack_public_path__ + "img/arrow-white.4a4b91b2.svg";